import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'importError',
    serviceName: 'shopadmin',
    query: gql`
      query importError($ids: [String]) {
        importError(ids: $ids) {
          import_error_records {
            data {
              id
              title
              barcode
              shop {
                id
              }
              co_price
              me_price
              introtext
              description
              brand_title
              booth_title
              category_title
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateProductShop',
    serviceName: 'shopadmin',
    query: gql`
      mutation updateProductShop(
        $ids: [String]
        $barcodes: [String]
        $product_id: String
        $shop_id: String
        $discount_type_id: String
        $co_price: String
        $me_price: String
        $stock: String
        $equivalent_code: String
        $nonexistent_number: String
        $max_number_buy: String
        $link_to: String
        $start_time: String
        $end_time: String
        $has_timer: Int
        $discount_value: String
        $discount_percent: String
        $is_active: Int
        $details: String
        $property_ids: [String]
        $booth_id: String
      ) {
        updateProductShop(
          ids: $ids
          barcodes: $barcodes
          product_id: $product_id
          shop_id: $shop_id
          discount_type_id: $discount_type_id
          co_price: $co_price
          me_price: $me_price
          stock: $stock
          equivalent_code: $equivalent_code
          nonexistent_number: $nonexistent_number
          max_number_buy: $max_number_buy
          link_to: $link_to
          start_time: $start_time
          end_time: $end_time
          has_timer: $has_timer
          discount_value: $discount_value
          discount_percent: $discount_percent
          is_active: $is_active
          details: $details
          property_ids: $property_ids
          booth_id: $booth_id
        ) {
          influenced_count
          messages
        }
      }
    `,
  },
};

export default schema;
